import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import moment from 'moment';


$(function () {
    var events = [];
    $(".fa-filter-content .fa-filter-content__item").each(function () {
        let doRefresh = $(this).data("refresh");
        if (doRefresh == "True") {
            var event = new Object();
            event.EventId = $(this).data("eventid");
            event.EventDayId = $(this).data("eventdayid");
            events.push(event);
        }
    });
    //console.log(events);

    if (events.length > 0) {
        $.ajax({
            url: '/api/sitecore/WSTickets/RefreshBuyButton',
            type: 'POST',
            data: JSON.stringify(events),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            success: function(response) {
              
                $.each(response.Data,
                    function (index, item) {
                        if (item.SoldOut) {
                            $("#btn-" + item.EventDayId).attr("href", "javascript:void(0)");
                            $("#btn-" + item.EventDayId).attr("class", "cta cta--alt cta--primary cta--primary-btn event-disabled-btn");
                            $("#sp-" + item.EventDayId).text("sold out");
                            if ($(".event-bundle").length > 0) {
                                $("#btn-" + item.EventDayId).attr("class", "cta cta--primary cta--standard cta--white disabled-btn");
                            }
                        }
                        else if (item.IsOnSale && !item.SoldOut) {
                            $("#btn-" + item.EventDayId).attr("href", item.TicketsUrl);
                            $("#btn-" + item.EventDayId).attr("class", "cta cta--alt cta--primary cta--primary-btn");
                            $("#sp-" + item.EventDayId).text(item.BuyButtonText);
                            if ($(".event-bundle").length > 0) {
                                $("#btn-" + item.EventDayId).attr("class", "cta cta--primary cta--standard cta--white");
                            }
                        }
                        else if (!item.IsOnSale && item.SaleStatus != "") {
                            $("#btn-" + item.EventDayId).attr("href", "javascript:void(0)");
                            $("#btn-" + item.EventDayId).attr("class", "cta cta--alt cta--primary cta--primary-btn event-disabled-btn");
                            $("#sp-" + item.EventDayId).text(item.SaleStatus);
                            if ($(".event-bundle").length > 0) {
                                $("#btn-" + item.EventDayId).attr("class", "cta cta--primary cta--standard cta--white disabled-btn");
                            }
                        }
                    });
            },
            failure: function(response) {
                console.log(response.responseText);
            },
            error: function(response) {
                console.log(response.responseText);
            },
            async: true,
            cache: false
        });
    }
});



// WEBPACK FOOTER //
// ./components/ws-events/scripts/events.js